import { 
  // OGLine, 
  // Vector3 
} from "./../../opengeometry/pkg/opengeometry";

export const OPEN_GEOMETRY_THREE_VERSION = '0.0.6';

export interface OpenGeometryOptions {
  wasmURL?: string;
}
